import RuleIcon from '@mui/icons-material/Rule';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Typography from '@mui/material/Typography';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { clearValidationErrors, erroValidationErrorsSelector } from '../state';
import DialogFlexSales from './DialogFlexSales';

const WARNING_CODES = ['REPROCESS_MONTH_CLOSED'];

const ValidationErrorAlert = () => {
  const errors = useSelector(erroValidationErrorsSelector);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const handleClose = useCallback(() => dispatch(clearValidationErrors()), [dispatch]);
  const data = (errors ?? [])
    .filter(err => err.code === 'MONTH_CLOSING_HAS_MISSINGS')
    .flatMap(err => err.msg)
    .sort((a, b) => {
      if (!a || !b) return 0;
      return new Date(a.businessDate).getTime() - new Date(b.businessDate).getTime();
    })
    .map(item => {
      if (!item) return '';
      const { store, businessDate, sales, colls } = item;

      const fields = [];

      if (sales) {
        fields.push(`${t('toolbar.labels.missing_sales')}: ❌`);
      }

      if (colls) {
        fields.push(`${t('toolbar.labels.missing_colls')}: ❌`);
      }

      if (fields.length === 0) return '';

      return `• ${store}_${businessDate} ${fields.join(' ')}`;
    })
    .filter(line => line.trim() !== '')
    .join('\n');

  if (!errors?.length) return null;

  // Si el mes está cerrado mostramos solo ese cartel y ocultamos el resto
  const hasMonthClosed = errors.some(err => err.code === 'REPROCESS_MONTH_CLOSED');
  const visibleErrors = hasMonthClosed
    ? errors.filter(err => err.code === 'REPROCESS_MONTH_CLOSED')
    : errors;

  return (
    <DialogFlexSales
      open
      onClose={handleClose}
      aria-describedby="alert-dialog-validation-error-description"
      dialogTitle={t('validations.title')}
      subtitle={t('validations.subtitle')}
      icon={<RuleIcon />}
    >
      <DialogContent>
        <DialogContentText id="alert-dialog-validation-error-description">
          {visibleErrors.map(err => {
            const isWarning = WARNING_CODES.includes(err.code);
            const message = t(`validations.${err.code}`, {
              field: t(`toolbar.labels.${err.field}`, { defaultValue: err.field }),
              msg: `\n${data}`,
            });
            return (
              <Alert key={`${err.code}-${err.field}`} severity={isWarning ? 'warning' : 'error'}>
                {isWarning ? (
                  <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                    {message}
                  </Typography>
                ) : (
                  <pre style={{ whiteSpace: 'pre-wrap', margin: 0 }}>{message}</pre>
                )}
              </Alert>
            );
          })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{t('common.ok')}</Button>
      </DialogActions>
    </DialogFlexSales>
  );
};

export default ValidationErrorAlert;
